/**
 * Check to see if the last time we fetched the video url was 10 seconds ago or more.
 */function isVideoUrlExpired(time){var differenceInSeconds=(new Date().getTime()-time)/1000;return differenceInSeconds>=10;}export{isVideoUrlExpired};